import React from 'react';

export interface FilterOption {
    label: string;
    value: string;
    variant?: 'primary' | 'success' | 'danger' | 'secondary';
    icon?: string; // FontAwesome icon class (e.g., 'fa-check-circle')
}

interface FilterButtonGroupProps {
    options: FilterOption[];
    selectedValue: string;
    onChange: (value: string) => void;
    ariaLabel?: string;
}

const FilterButtonGroup: React.FC<FilterButtonGroupProps> = ({ 
    options, 
    selectedValue, 
    onChange, 
    ariaLabel = 'Filter options' 
}) => {
    return (
        <div className="btn-group" role="group" aria-label={ariaLabel}>
            {options.map((option) => {
                const isActive = selectedValue === option.value;
                const variant = option.variant || 'primary';
                const buttonClass = isActive 
                    ? `btn btn-sm btn-${variant}` 
                    : `btn btn-sm btn-outline-secondary`;

                return (
                    <button
                        key={option.value}
                        type="button"
                        className={buttonClass}
                        onClick={() => onChange(option.value)}
                    >
                        {option.icon && <i className={`fal ${option.icon} fa-fw`} />}
                        {option.label}
                    </button>
                );
            })}
        </div>
    );
};

export default FilterButtonGroup;

